import { Menu } from "@mantine/core";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect } from "react";
import { FloatingActionButton } from "shared/components/global/FloatingActionButton/FloatingActionButton";
import { usePermissionCheck } from "shared/stores/oidc";
import { useAside } from "shared/utils/aside";
import { Permission } from "src/gql/graphql";

function component() {
    const aside = useAside();
    const hasIpawsCreate = usePermissionCheck(Permission.IpawsAlertModify);

    useEffect(() => {
        aside.dismiss({ silent: true });
    }, []);

    return hasIpawsCreate ? (
        <FloatingActionButton>
            <Menu.Item component={Link} to="/ipaws/alerts/new">
                New IPAWS Alert
            </Menu.Item>
        </FloatingActionButton>
    ) : null;
}

/** @public */
export const Route = createFileRoute("/_auth/ipaws/certificates/")({
    component,
});
